import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatEUR } from "@/lib/constants";
import { Hourglass, WarningCircle, ArrowRight } from "@phosphor-icons/react";

// Dashboard: laufende Mieterhöhungen mit Handlungsbedarf
export default function RunningRentIncreases() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/rent-increase/dashboard-running").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d?.items?.length) return null;
  return (
    <div className="bg-white border border-indigo-200 rounded-md overflow-hidden" data-testid="dashboard-running-rent-increases">
      <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-b border-indigo-100 bg-indigo-50/60">
        <Hourglass size={16} className="text-indigo-800" />
        <h2 className="text-sm font-semibold text-indigo-900">Laufende Mieterhöhungen</h2>
        <span className="text-xs text-indigo-800" data-testid="running-ri-summary">{d.items.length} laufend · {d.urgent} mit Handlungsbedarf</span>
        <Link to="/mieterhoehungen" className="ml-auto text-xs font-medium text-indigo-800 hover:text-indigo-950 inline-flex items-center gap-1" data-testid="running-ri-open-all">Alle anzeigen <ArrowRight size={12} /></Link>
      </div>
      <div className="divide-y divide-slate-100 max-h-56 overflow-y-auto">
        {d.items.slice(0, 8).map((it) => (
          <Link key={it.id} to={`/mietverhaeltnisse/${it.tenancy_id}?tab=mieterhoehung`} className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-slate-50" data-testid={`running-ri-${it.id}`}>
            {it.urgent ? <WarningCircle size={15} className="text-rose-600 shrink-0" /> : <span className="w-[15px]" />}
            <span className="font-mono text-xs w-28 shrink-0">{it.contract_number}</span>
            <span className="text-xs w-44 shrink-0 truncate text-slate-700" title={it.tenant_names}>{it.tenant_names}</span>
            <span className={`font-mono text-xs w-28 shrink-0 ${it.case_number ? "font-semibold text-slate-900" : "text-slate-400"}`} data-testid={`running-ri-az-${it.id}`}>{it.case_number ? `Az. ${it.case_number}` : "ohne Az."}</span>
            <span className="text-xs text-slate-600 w-48 shrink-0 truncate">{it.status_label}</span>
            <span className={`flex-1 text-xs truncate ${it.urgent ? "text-rose-700 font-medium" : "text-slate-700"}`}>{it.todo}</span>
            <span className="text-xs tabular-nums text-slate-600 hidden md:inline">{formatEUR(it.current_rent)} → {formatEUR(it.new_rent)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
